// extracted by mini-css-extract-plugin
export default {"content":"Schools_content__jQ7-v","content2":"Schools_content2__bu9qn","content3":"Schools_content3__gkf6k","link":"Schools_link__l2-HX"};